module.exports = __webpack_public_path__ + "media/images/application/template/logos/arnold-clark-a184b88278d2ee4a4312090464c292f2.png";